import type { Texture } from "pixi.js";

export const ensureReady = async (tex: Texture): Promise<void> => {
  function texDimsLocal(t: Texture) {
    const w = t.frame?.width || t.width || t.baseTexture.width || 0;
    const h = t.frame?.height || t.height || t.baseTexture.height || 0;
    return { w, h };
  }
  const { w, h } = texDimsLocal(tex);
  if (w > 0 && h > 0) return;
  await new Promise<void>((resolve) => {
    const base = tex.baseTexture;
    const done = () => {
      const d = texDimsLocal(tex);
      if (d.w > 0 && d.h > 0) {
        base?.off?.("update", done);
        resolve();
      }
    };
    base?.on?.("update", done);
    // Fallback: tick a few frames if no event fires
    setTimeout(done, 0);
  });
};
